/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetCharactersCharacterIdBookmarksCoordinates } from './GetCharactersCharacterIdBookmarksCoordinates';
import {
    GetCharactersCharacterIdBookmarksCoordinatesFromJSON,
    GetCharactersCharacterIdBookmarksCoordinatesFromJSONTyped,
    GetCharactersCharacterIdBookmarksCoordinatesToJSON,
    GetCharactersCharacterIdBookmarksCoordinatesToJSONTyped,
} from './GetCharactersCharacterIdBookmarksCoordinates';
import type { GetCharactersCharacterIdBookmarksItem } from './GetCharactersCharacterIdBookmarksItem';
import {
    GetCharactersCharacterIdBookmarksItemFromJSON,
    GetCharactersCharacterIdBookmarksItemFromJSONTyped,
    GetCharactersCharacterIdBookmarksItemToJSON,
    GetCharactersCharacterIdBookmarksItemToJSONTyped,
} from './GetCharactersCharacterIdBookmarksItem';

/**
 * 200 ok object
 * @export
 * @interface GetCharactersCharacterIdBookmarks200Ok
 */
export interface GetCharactersCharacterIdBookmarks200Ok {
    /**
     * bookmark_id integer
     * @type {number}
     * @memberof GetCharactersCharacterIdBookmarks200Ok
     */
    bookmarkId: number;
    /**
     * 
     * @type {GetCharactersCharacterIdBookmarksCoordinates}
     * @memberof GetCharactersCharacterIdBookmarks200Ok
     */
    coordinates?: GetCharactersCharacterIdBookmarksCoordinates;
    /**
     * created string
     * @type {Date}
     * @memberof GetCharactersCharacterIdBookmarks200Ok
     */
    created: Date;
    /**
     * creator_id integer
     * @type {number}
     * @memberof GetCharactersCharacterIdBookmarks200Ok
     */
    creatorId: number;
    /**
     * folder_id integer
     * @type {number}
     * @memberof GetCharactersCharacterIdBookmarks200Ok
     */
    folderId?: number;
    /**
     * 
     * @type {GetCharactersCharacterIdBookmarksItem}
     * @memberof GetCharactersCharacterIdBookmarks200Ok
     */
    item?: GetCharactersCharacterIdBookmarksItem;
    /**
     * label string
     * @type {string}
     * @memberof GetCharactersCharacterIdBookmarks200Ok
     */
    label: string;
    /**
     * location_id integer
     * @type {number}
     * @memberof GetCharactersCharacterIdBookmarks200Ok
     */
    locationId: number;
    /**
     * notes string
     * @type {string}
     * @memberof GetCharactersCharacterIdBookmarks200Ok
     */
    notes: string;
}

/**
 * Check if a given object implements the GetCharactersCharacterIdBookmarks200Ok interface.
 */
export function instanceOfGetCharactersCharacterIdBookmarks200Ok(value: object): value is GetCharactersCharacterIdBookmarks200Ok {
    if (!('bookmarkId' in value) || value['bookmarkId'] === undefined) return false;
    if (!('created' in value) || value['created'] === undefined) return false;
    if (!('creatorId' in value) || value['creatorId'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('locationId' in value) || value['locationId'] === undefined) return false;
    if (!('notes' in value) || value['notes'] === undefined) return false;
    return true;
}

export function GetCharactersCharacterIdBookmarks200OkFromJSON(json: any): GetCharactersCharacterIdBookmarks200Ok {
    return GetCharactersCharacterIdBookmarks200OkFromJSONTyped(json, false);
}

export function GetCharactersCharacterIdBookmarks200OkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCharactersCharacterIdBookmarks200Ok {
    if (json == null) {
        return json;
    }
    return {
        
        'bookmarkId': json['bookmark_id'],
        'coordinates': json['coordinates'] == null ? undefined : GetCharactersCharacterIdBookmarksCoordinatesFromJSON(json['coordinates']),
        'created': (new Date(json['created'])),
        'creatorId': json['creator_id'],
        'folderId': json['folder_id'] == null ? undefined : json['folder_id'],
        'item': json['item'] == null ? undefined : GetCharactersCharacterIdBookmarksItemFromJSON(json['item']),
        'label': json['label'],
        'locationId': json['location_id'],
        'notes': json['notes'],
    };
}

export function GetCharactersCharacterIdBookmarks200OkToJSON(json: any): GetCharactersCharacterIdBookmarks200Ok {
    return GetCharactersCharacterIdBookmarks200OkToJSONTyped(json, false);
}

export function GetCharactersCharacterIdBookmarks200OkToJSONTyped(value?: GetCharactersCharacterIdBookmarks200Ok | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'bookmark_id': value['bookmarkId'],
        'coordinates': GetCharactersCharacterIdBookmarksCoordinatesToJSON(value['coordinates']),
        'created': ((value['created']).toISOString()),
        'creator_id': value['creatorId'],
        'folder_id': value['folderId'],
        'item': GetCharactersCharacterIdBookmarksItemToJSON(value['item']),
        'label': value['label'],
        'location_id': value['locationId'],
        'notes': value['notes'],
    };
}

